import { Suspense } from "react";
import { createBrowserRouter, RouteObject } from "react-router";

const isKiosk = import.meta.env.VITE_APP_TARGET === "kiosk";

// Wrap routes with Suspense for lazy loading
const routesWithSuspense = (routes: RouteObject[]): RouteObject[] => {
  return routes.map(route => {
    const newRoute: RouteObject = {
      ...route,
      element: route.element ? (
        <Suspense fallback={<div>Loading...</div>}>{route.element}</Suspense>
      ) : (
        route.element
      ),
    };

    if (route.children) {
      newRoute.children = routesWithSuspense(route.children);
    }

    return newRoute;
  });
};

// Dynamically import routes based on target to avoid bundling unused code
const loadRoutes = async () => {
  if (isKiosk) {
    const { KioskRoutes } = await import("./KioskRoutes");
    return KioskRoutes;
  } else {
    const { WebRoutes } = await import("./WebRoutes");
    return WebRoutes;
  }
};

// Create router with dynamic routes
export const createAppRouter = async () => {
  const routes = await loadRoutes();
  return createBrowserRouter(routesWithSuspense(routes));
};

// For backward compatibility, export a promise that resolves to the router
export const routerPromise = createAppRouter();
